/**
 * 跟財務相關的 Composable
 */

interface IBalance {
  currency: string;
  point: number;
}

export function useFinance() {
  const { $i18n } = useNuxtApp();
  const { locale } = $i18n;

  // 回傳 Currency Balance

  const provideBalance = ({ currency, point }: IBalance): string => {
    const price: string = formatFinanceNumber(point);

    if (locale.value === EnumLocale.JA_JP) {
      return `GV ${price}`;
    }
    return `${currency} ${price}`;
  };

  return { provideBalance };
}
